var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29303 12.293C5.10556 12.4805 5.00024 12.7348 5.00024 13C5.00024 13.2652 5.10556 13.5195 5.29303 13.707L9.29303 17.707C9.48056 17.8945 9.73487 17.9998 10 17.9998C10.2652 17.9998 10.5195 17.8945 10.707 17.707L14.707 13.707C14.8892 13.5184 14.99 13.2658 14.9877 13.0036C14.9854 12.7414 14.8803 12.4906 14.6948 12.3052C14.5094 12.1198 14.2586 12.0146 13.9964 12.0123C13.7342 12.01 13.4816 12.1108 13.293 12.293L11 14.586L11 3C11 2.73478 10.8947 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2C9.73481 2 9.48046 2.10536 9.29292 2.29289C9.10539 2.48043 9.00003 2.73478 9.00003 3L9.00003 14.586L6.70703 12.293C6.5195 12.1055 6.26519 12.0002 6.00003 12.0002C5.73487 12.0002 5.48056 12.1055 5.29303 12.293Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.4ebf73ae97a40db364ab6d983bab6bd8.svg";
export { ForwardRef as ReactComponent };